import { render, staticRenderFns } from "./yardCoupon.vue?vue&type=template&id=965cd276"
import script from "./yardCoupon.vue?vue&type=script&lang=js"
export * from "./yardCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports